import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import SideBar from 'src/components/SideBar'
import { useNavigate, useLocation } from 'react-router-dom'
import nav from 'src/router/nav'
import styles from './DefaultLayout.module.scss'
import { pathUrl } from 'src/variable/constant'
import { FaAlignJustify } from 'react-icons/fa'

function DefaultLayout({ children }) {
	const navigate = useNavigate()
	const location = useLocation()
	const [show, setShow] = useState(false)

	useEffect(() => {
		const info = localStorage.getItem('info')
		const token = localStorage.getItem('token')
		const refresh_token = localStorage.getItem('refresh_token')

		if (!info || !token || !refresh_token) {
			localStorage.clear()
			navigate('/login')
			return
		}
		
		try {
			const userInfo = JSON.parse(info)
			const userRole: string = userInfo?.role
			const employeeRoles: string[] = Array.isArray(userInfo?.employee_roles)
				? userInfo.employee_roles.map((role: any) => (typeof role === 'string' ? role : role?.name || ''))
				: []

			// If SUPERADMIN, allow all routes
			if (userRole === 'SUPERADMIN') {
				return
			}

			// Check permission for current route
			const checkAccessible = (permission?: string, role?: string) => {
				if (role && userRole !== role) return false
				if (!permission) return true
				return employeeRoles.some(
					(r) => r === permission || permission.startsWith(r + ':'),
				)
			}

			// Find current route in nav
			const pathname = location.pathname
			let hasAccess = true

			const findRoute = (items: typeof nav): boolean => {
				for (const item of items) {
					if (item.children?.length) {
						for (const child of item.children) {
							if (child.to === pathname) {
								return checkAccessible(child.permission, child.role)
							}
						}
						if (findRoute(item.children)) {
							return true
						}
					} else if (item.to === pathname) {
						return checkAccessible(item.permission, item.role)
					}
				}
				return false
			}

			hasAccess = findRoute(nav)

			if (!hasAccess && pathname !== pathUrl.myProfile) {
				navigate(pathUrl.myProfile)
			}
		} catch (error) {
			console.error('Error checking access', error)
		}
	}, [navigate, location.pathname])

	// if (!isAccessible) {
	// 	return null
	// }

	return (
		<Stack direction="row" className={styles.wrapprer}>
			<SideBar show={show} setShow={setShow} />
			<Box flex={1} className={styles.body}>
				<button
					type="button"
					className={styles.mobileMenuButton}
					onClick={() => setShow((pre) => !pre)}
					aria-label="Open sidebar"
				>
					<FaAlignJustify />
				</button>
				<Grid
					container
					style={{
						minHeight: '100vh',
						width: '100%',
						padding: 16,
					}}
					onClick={() => setShow(false)}
				>
					{children}
				</Grid>
			</Box>
		</Stack>
	)
}

export default DefaultLayout
